import { accounts } from "./accounts/accounts";
import { contacts } from "./contacts/contacts";
import { invoices } from "./invoices/invoices";
import { payments } from "./payments/payments";
import { variances } from "./variances/variances";
import { bankAccounts } from "./bankAccounts/bankAccounts";
import { billingCommitments } from "./billingCommitments/billingCommitments";
import { contactCategories } from "./contactCategories/contactCategories";
import { creditMemos } from "./creditMemos/creditMemos";
import { invoiceItems } from "./invoiceItems/invoiceItems";
import { invoiceSubItems } from "./invoiceSubItems/invoiceSubItems";
import { laborRates } from "./laborRates/laborRates";
import { qBOItemMappings } from "./qBOItemMappings/qBOItemMappings";
import { quickBooks } from "./quickBooks/quickBooks";
import { quickBooksAudit } from "./quickBooksAudit/quickBooksAudit";
import { quickBooksAuth } from "./quickBooksAuth/quickBooksAuth";
import { quickBooksItems } from "./quickBooksItems/quicBoooksItems";

export const accountService = {
  accounts,
  contacts,
  contactCategories,
  invoiceSubItems,
  invoiceItems,
  invoices,
  billingCommitments,
  quickBooksAuth,
  quickBooks,
  variances,
  quickBooksAudit,
  quickBooksItems,
  bankAccounts,
  laborRates,
  payments,
  creditMemos,
  qBOItemMappings,
};
